import React from 'react';
import PageLayout from '../components/PageLayout';

const RefundPolicy = () => (
  <PageLayout title="Refund & Cancellation Policy">
    <p><strong>Last Updated:</strong> May 29, 2026</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>1. Order Cancellation</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>You may cancel your order before it is marked as "Ready for Pickup".</li>
      <li>Once an order is marked as ready, cancellation is not possible.</li>
      <li>To cancel an order, go to My Orders in the app and tap "Cancel Order".</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>2. Refund Eligibility</h2>
    <p>Refunds are applicable in the following cases:</p>
    <ul style={{ paddingLeft: 20 }}>
      <li>Order cancelled before preparation</li>
      <li>Wrong items received</li>
      <li>Damaged or expired products</li>
      <li>Missing items from your order</li>
      <li>Payment charged but order not confirmed</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>3. Refund Process</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>Refunds for cancelled orders will be processed within 5-7 business days.</li>
      <li>Refunds will be credited to the original payment method or app wallet.</li>
      <li>Wallet refunds are instant. Bank refunds may take 5-7 business days.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>4. Non-Refundable Cases</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>Orders not picked up within 2 hours of being ready</li>
      <li>Change of mind after order is prepared</li>
      <li>Incorrect pickup point selected by the user</li>
      <li>Promotional or free items</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>5. How to Request a Refund</h2>
    <p>To request a refund:</p>
    <ol style={{ paddingLeft: 20 }}>
      <li>Open the Chakna Point app</li>
      <li>Go to My Orders → Select the order</li>
      <li>Tap "Report Issue" or "Request Refund"</li>
      <li>Provide details and photos (if applicable)</li>
      <li>Our team will review and process within 24-48 hours</li>
    </ol>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>6. Contact Us</h2>
    <p>For refund-related queries, contact us at:</p>
    <p><strong>Email:</strong> support@chaknapoint.com<br /><strong>Phone:</strong> +91 98765 43210</p>
  </PageLayout>
);

export default RefundPolicy;
